import React from "react";
import { NavLink } from "react-router-dom";
import { Shield, Mic, LayoutDashboard, Users, BarChart3, CreditCard, Phone, Bot, Lock, Activity, Megaphone, Ticket, Settings, LogOut, Package } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true, id: "overview" },
  { to: "/admin/clients", label: "Clients", icon: Users, id: "clients" },
  { to: "/admin/analytics", label: "Platform Analytics", icon: BarChart3, id: "analytics" },
  { to: "/admin/billing", label: "Billing & Subscriptions", icon: CreditCard, id: "billing" },
  { to: "/admin/telephony", label: "Telephony", icon: Phone, id: "telephony" },
  { to: "/admin/ai", label: "AI Models & Config", icon: Bot, id: "ai" },
  { to: "/admin/security", label: "Security & Access", icon: Lock, id: "security" },
  { to: "/admin/system", label: "System Health", icon: Activity, id: "system" },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone, id: "announcements" },
  { to: "/admin/tickets", label: "Support Tickets", icon: Ticket, id: "tickets" },
  { to: "/admin/settings", label: "Platform Settings", icon: Settings, id: "settings" },
  { to: "/admin/updates", label: "Updates & Patches", icon: Package, id: "updates" },
];

export default function AdminSidebar({ open, onClose }) {
  const { admin, logout } = useAdminAuth();
  return (
    <>
      {open && <div className="fixed inset-0 bg-black/50 z-30 lg:hidden" onClick={onClose} />}
      <aside className="fixed lg:static z-40 h-screen w-64 flex flex-col text-slate-200" style={{ background: "#0C0A1E" }} data-testid="admin-sidebar">
        <div className="px-5 py-5 border-b border-white/10 flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center shadow-lg shrink-0" style={{ background: "#7C3AED", boxShadow: "0 8px 24px rgba(124,58,237,0.4)" }}>
            <Mic className="w-5 h-5 text-white" />
          </div>
          <div className="min-w-0">
            <div className="font-display font-bold text-sm leading-tight">PK AI Calling</div>
            <div className="text-[10px] font-bold tracking-widest" style={{ color: "#06B6D4" }}>SALES AGENT · ADMIN</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={onClose} data-testid={`admin-nav-${n.id}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "text-white" : "text-slate-400 hover:text-white hover:bg-white/5"}`}
              style={({ isActive }) => (isActive ? { background: "rgba(124,58,237,0.25)" } : {})}>
              <n.icon className="w-[18px] h-[18px]" />
              <span className="flex-1">{n.label}</span>
              {n.soon && <span className="text-[9px] px-1 py-0.5 rounded bg-white/10 text-slate-400">soon</span>}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-white/10">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{ background: "linear-gradient(135deg,#7C3AED,#06B6D4)" }}>{(admin?.name || "A").slice(0, 1)}</div>
            <div className="flex-1 min-w-0"><div className="text-sm font-medium truncate">{admin?.name || "Admin"}</div><div className="text-[11px] text-slate-500 capitalize">{(admin?.role || "").replace("_", " ")}</div></div>
          </div>
          <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-white hover:bg-white/5" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Logout</button>
        </div>
      </aside>
    </>
  );
}
